export const SHOW_RECEPTIVE_FIELD = true;
export const TC_MOSAIC_SIZE = 640;